// teachers subject assignment for classes 
import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const TcsContext = createContext();

export function TcsDataProvider({ children }) {
  const [subjectAssignment, setSubjectAssignment] = useState([]);
  const [loadingSD, setLoadingSD] = useState(false);

  
  const fetchScheduledClasses = async () => {
    try {
      setLoadingSD(true);
      const response = await fetch(`${config.apiBaseUrl}/staffs/fetchAssignedTask.php`);
      const data = await response.json();
      setSubjectAssignment(data);
    } catch (error) {
      console.error('Error fetching fee data:', error);
    } finally {
      setLoadingSD(false);
    }
  };

  useEffect(() => {
    fetchScheduledClasses();
  }, []);

  const refetchSCData = () => {
    fetchScheduledClasses();
  };

  return (
    <TcsContext.Provider value={{ subjectAssignment, loadingSD, refetchSCData }}>
      {children}
    </TcsContext.Provider>
  );
}

export function useTCSData() {
  const context = useContext(TcsContext);
  if (context === undefined) {
    throw new Error('useTCSData must be used within a TcsDataProvider');
  }
  return context;
}
